import { Grid } from "@trussworks/react-uswds";
import { Fragment, useEffect, useState } from "react";
import { ReactComponent as HealthFirstColorado } from "../../images/hcpf_logo.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

type HCPFCardProps = {
  isMobile: boolean;
};

const GetCardText = () => {
  const { t } = useTranslation();
  return (
    <div className="align-me-text">
      <div className="inner-text-style">
        <p>{t("hcpfbannerHeader")}</p>
        <ReactMarkdown className="p-hcpf-banner-2nd-line">
          {t("hcpfbannertext")}
        </ReactMarkdown>
      </div>
    </div>
  );
};

const GetHCPFCardLogo = () => {
  return (
    <div className="align-me-logo">
      <HealthFirstColorado className="centerSvg" />
    </div>
  );
};

const GetCardMobileText = () => {
  const { t } = useTranslation();
  return (
    <div className="align-me-mobile-text">
      <p>{t("hcpfbannerHeader")}</p>
      <ReactMarkdown>
        {t("hcpfbannertext")}
      </ReactMarkdown>
    </div>
  );
};

const GetHCPFCardMobileLogo = () => {
  return (
    <div className="div-hcpf-mobile-logo">
      <img
        id="imgHcpfMobileLogo"
        alt="Health First Colorado"
        src={require("../../images/health_first_colorado.svg").default}
      />
    </div>
  );
};

export default function HCPFCard({ isMobile }: HCPFCardProps) {
  const [isBannerMobile, setIsBannerMobile] = useState(
    window.innerWidth < 1400
  );
  let innerWidth = window.innerWidth;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1400 && isBannerMobile === false) {
        setIsBannerMobile(true);
      } else if (window.innerWidth >= 1400 && isBannerMobile === true) {
        setIsBannerMobile(false);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [isBannerMobile, innerWidth]);

  // removed these styles  grid-container behav-health-card

  if (!isMobile && !isBannerMobile) {
    return (
      <Fragment>
        <div className="border-bottom border-bottom-lighter">
          <div
            className="hcpf-card"
            id={isMobile ? "hcpfcardmobile" : "hcpfcard"}
            key="999999999"
          >
            <Grid
              row
              mobile={{ col: true }}
              className="flex-justify-center tablet:flex-justify flex-align-center hcpf-card-div"
            >
              <div className="div-parent">
                <GetHCPFCardLogo />
                <GetCardText />
              </div>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="border border-base-lighter radius-lg padding-2 margin-bottom-1">
        <div
          className="hcpf-card-mobile hcpf-card-div"
          id={isMobile ? "hcpfcardmobile" : "hcpfcard"}
          key="999999999"
        >
          <div className="grid-row mobile:grid-col flex-justify-center tablet:flex-justify flex-align-center align-me-mobile-logo">
            <GetHCPFCardMobileLogo />
            <GetCardMobileText />
          </div>
        </div>
      </div>
    </Fragment>
  );
}
